import { render, staticRenderFns } from "./ProcedureScholarship.vue?vue&type=template&id=f94581a0&scoped=true"
import script from "./ProcedureScholarship.vue?vue&type=script&lang=js"
export * from "./ProcedureScholarship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94581a0",
  null
  
)

export default component.exports